import { withStyles } from '@material-ui/core';

import ReferenceItem from './component';
import styles from './styles';

export default withStyles(styles)(ReferenceItem);
